import {
  inventoryItemIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import * as z from "zod";

/** Multipart: the photo travels as `files` alongside this input. */
export const uploadShippingLabelPhoto = {
  name: "uploadShippingLabelPhoto" as const,
  input: z.object({
    // Attach to an existing item, or omit to create a new UNKNOWN item
    // at locationId (required in that case).
    inventoryItemId: inventoryItemIdFormat.schema.optional(),
    locationId: locationIdFormat.schema.optional(),
  }),
  output: z.object({
    scanId: z.string(),
    inventoryItemId: inventoryItemIdFormat.schema,
  }),
};
